import React  , {useState}  from "react";
import { useSelector } from "react-redux";

import { queryClient } from '../../state/queryClient';

import { enregistrerformuleinterne } from "../../utils/utils_contratwin";
import { dateconvert } from "../../utils/utils_dates";


import ButtonSimple from "../Buttons/ButtonSimple";

import './ModifContrat.scss' ;
import './FormuleDetail.scss' ; 

const listchamps ={'nom_titulaire':'Nom du titulaire','prenom_titulaire':'Prénom du titulaire',
                   'prix':'Prix','date_effet':'Date d’effet'}  

function FormuleDetail({setShowFormuleDetail,choicedformule}){
   console.log('choicedformule',choicedformule) ;
         const  user = queryClient.getQueryData(['user',localStorage.getItem('token')]);
        const lead = useSelector(state=>state.lead.leadactu) ;
        
        const formsigninitial = {'manager':user?.manager,'date_originelead': lead.date_origine,
                                 'campagne': lead.campagne, 'origine': lead.origine,
                                 "nom_titulaire":lead.nom,"prenom_titulaire":lead.prenom,
                                 'courtier':lead.courtier, 'id_lead':lead.id,'id_client':lead.id_client,
                                'nom_titulaire':lead.nom,'prenom_titulaire':lead.prenom,
                                'commercial':lead.commercial,'email':lead.email,'date_effet':lead.date_effet,
                                'compagnie': choicedformule.compagnie,'gamme':choicedformule.gamme,
                                'formule' :choicedformule.nom_formule,'etat_contrat':'projet',
                                'prix': choicedformule.prix ,'hospi': choicedformule.hospi,
                                'consults_specialistes_nb' : choicedformule.consults_specialistes_nb,
                                'optique_lunettes_nb' : choicedformule.optique_lunettes_nb,
                                'optique_lentilles_nb' : choicedformule.optique_lentilles_nb,
                                'dentaire_prothese_nb' : choicedformule.dentaire_prothese_nb ,
                                'dentaire_implant_nb' : choicedformule.dentaire_implant_nb,
                                'dentaire_orthodontie_nb' : choicedformule.dentaire_orthodontie_nb ,
                                'prevention' : choicedformule.prevention,
                                'type_tarif' : choicedformule.type_tarif,
                                // DEV SOUSCRIPTION
                              // 'souscription':choicedformule.souscription
                              }


        const [contrat, setcontrat] = useState(formsigninitial) ; 
          
        const handleChange =(e)=>{ setcontrat({...contrat,[e.target.id]: e.target.value}) ;}

        const grplabelinput = (x,label)=>( <div key={x}  className="formuledetail_labelinput" >
                                                <div className="formuledetail_label">{label}</div>
                                                <input id={x} type={(x==='date_effet' )?"date":"text"} disabled={x==='date_effet'} onChange={handleChange}
                                                      value={(x==='date_effet' )?dateconvert(contrat[x]) :contrat[x]}  />
                                           </div>) ;

        const enregistrerformule_interne =async()=>{ setShowFormuleDetail(false);
                                                     await enregistrerformuleinterne(contrat)  ;
                                                      queryClient.invalidateQueries({queryKey:['contrats',lead?.email,lead?.courtier]}) ;
                                                      queryClient.invalidateQueries({ queryKey: ['devis',lead?.id]}) ; 
                                                   }

        return(<><div className="modifcontrat_form">{Object.keys(listchamps).map(x=>( grplabelinput(x,listchamps[x]) ))}</div>
                <div className="formuledetail_btn">
                   <ButtonSimple  texte="Valider"   color='bouton_color_orange' size='bouton_size_normal'  disable={false}  onclick={()=>enregistrerformule_interne(choicedformule)}     /> 
                </div> 
               </> )

}
   

export default FormuleDetail